import { ToolTemplateTool } from './tool-template-tool';

export class ToolTemplate {
  constructor(
    public hash?: string,
    public name?: string,
    public description?: string,
    public tools?: ToolTemplateTool[]
  ) { }

  clone() {
    return new ToolTemplate (
      this.hash,
      this.name,
      this.description,
      this.tools
    );
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/tool-template.ts